import React, { useState } from 'react';
import { Modal, Box, TextField, Button, MenuItem, Select, FormControl, InputLabel, Typography } from '@mui/material';
import { addUser } from '../../api/axios';
import { useTranslation } from 'react-i18next';
import './addUser.css';
import { decryptToken } from '../../utils/Crypto';


const AddUserModal = ({ open, handleClose }) => {
  const { t } = useTranslation('global');
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    ac_lvl: '',
  });
  const [errorMessage, setErrorMessage] = useState('');

  const accessToken = localStorage.getItem("accessToken");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const params = new URLSearchParams();
      params.append('username', formData.username);
      params.append('password', formData.password);
      params.append('email', formData.email);
      params.append('ac_lvl', formData.ac_lvl);
      params.append('accessToken', accessToken);

      const response = await addUser(params);

      const { success, message } = response.data;
      if (success) {
        console.log(t('addUser.userAddedSuccessfully'));
        handleClose();
      } else {
        setErrorMessage(message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          setErrorMessage(t('addUser.tokenError'));
        } else if (error.response.status === 400) {
          setErrorMessage(t('addUser.tokenError'));
        } else if (error.response.status === 405) {
          setErrorMessage(t('addUser.methodNotAllowed'));
        } else {
          setErrorMessage(t('addUser.unexpectedError'));
        }
      } else {
        setErrorMessage(t('addUser.networkError'));
      }
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          {t('addUser.addANewUser')}
        </Typography> {/* Modal title */}
        
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label={t('addUser.username')}
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            label={t('addUser.password')}
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            label={t('addUser.email')}
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="access-level-label">{t('addUser.accessLevel')}</InputLabel>
            <Select
              labelId="access-level-label"
              label={t('addUser.accessLevel')}
              name="ac_lvl"
              value={formData.ac_lvl}
              onChange={handleChange}
              required
            >
              <MenuItem value="administrator">{t('addUser.administrator')}</MenuItem>
              <MenuItem value="korisnik">{t('addUser.user')}</MenuItem>
            </Select>
          </FormControl>

        <Button 
          type="submit" 
          variant="contained" 
          color="primary" 
          className="centeredButton"
        >
          {t('addUser.addUser')}
        </Button>

        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
        </form>
      </Box>
    </Modal>
  );
};

export default AddUserModal;

